module.exports = __webpack_public_path__ + "media/brands/cleveland-cycle-werks-33ac28e6.png";